import React, { Component } from 'react'
import Axios from 'axios';
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import TopBar from '../topbar/topbar'
import search from '../assets/search.png'
import { BASE } from '../api/api';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'
import tmp_img from '../assets/pr.jpg'
import home from '../assets/Home/home.png'
import togglearrow from '../assets/Home/togglearrow.png'
import crumbarrow from '../assets/Home/right.png'
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'
import './clusters.css'
import { List } from 'react-content-loader';

import ReactPaginate from 'react-paginate';
import HtmlParser from 'react-html-parser';

// import 'bootstrap/dist/css/bootstrap.min.css';

const url = 'http://ifdb-be.tridz.in/'

const completed_data = [
    { lead: ["Fintech, Digital Currency", " (Palgrave Macmillan)"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
]
const publication_data = [
    { lead: ["Fintech, Digital Currency", " (Palgrave Macmillan)"], title: 'Alam, Nafis & Ali, Syed Nazim', grant: "Book Chapter", year: "2020" },
    { lead: ["Morocco Chapter on Shariah", "Governance in Islamic Finance"], title: 'Aassouli, Dalal', grant: "Book", year: "2020" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
]

const members_data = [
    { img: "/clusters/ifdbPerson.jpg", name: "Dr. Syed Nazim Ali", desg: "Director" },
    { img: "/clusters/ifdbPerson.jpg", name: "Saqid Hafiz Khateeb", desg: "IBIR-Project Lead" },
    { img: "/clusters/ifdbPerson.jpg", name: "Umar Farooq patel", desg: "Research Fellow" },
    { img: "/clusters/ifdbPerson.jpg", name: "Bahnaz Ali Al-Quradaghi", desg: "Researcher" },
    { img: "/clusters/ifdbPerson.jpg", name: "Zul hakim bin Jumat", desg: "Researcher" },
]

class Clusters extends Component {

    constructor(props) {
        super(props);
        this.state = {
            size: 10,
            tab: 1,
            offsetproject: 0,
            offsetpub: 0,
            offsetevent: 0
        }
    }
    componentDidMount() {
        let link = this.props.match.params.id
        let links = link.replace(/-/g, ' ')
        console.log('id', links)
        this.loadDetails(links)
    }
    loadDetails(id) {
        Axios.get(`${BASE}jsonapi/node/faculty?include=field_author_faculty`)
            .then(item => {
                this.setState({
                    faculty: item.data.data
                })
            })
            .catch(err => {
                console.log("faculty not found", err)
            })
        Axios.get(`${BASE}jsonapi/node/research_clusters?include=field_members_cluster,field_members_cluster.field_member,field_members_cluster.field_member.field_image&filter[title]=${id}`)
            .then(data => {
                console.log("cluster details", data.data.data)
                if (data.data.data.length) {
                    this.setState({
                        cluster: data.data.data[0],
                        included: data.data.included
                    })
                    if (data.data.data[0].relationships.field_members_cluster.data) {
                        this.setState({
                            members: data.data.data[0].relationships.field_members_cluster.data.length
                        })
                    }
                }
            })
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_research__cluster,field_select_work_to_submit,field_author&filter[field_research__cluster.title]=${id}&page[offset]=${this.state.offsetpub}&page[limit]=10&sort=-field_year`)
            .then(data => {
                console.log("cluster details pub", data.data)
                this.setState({
                    pub: data.data.data,
                    pubincluded: data.data.included,
                    pubcount: data.data.meta ? data.data.meta.count : null

                })
                if (data.data.links.next)
                    this.setState({
                        pubnext: true
                    })
                else
                    this.setState({
                        pubnext: false
                    })
            })
        Axios.get(`${BASE}jsonapi/node/events?include=field_event_type,field_research_cluster_event&filter[field_research_cluster_event.title]=${id}&page[offset]=${this.state.offsetevent}&page[limit]=10&sort=-field_date`)
            .then(data => {
                console.log("cluster details events", data.data)
                this.setState({
                    events: data.data.data,
                    eventincluded: data.data.included,
                    eventcount: data.data.meta ? data.data.meta.count : null

                })
                if (data.data.links.next)
                    this.setState({
                        eventnext: true
                    })
                else
                    this.setState({
                        eventnext: false
                    })
            })
        Axios.get(`${BASE}jsonapi/node/project?include=field_cis_cluster,field_lead_project__investigator,field_grant_authoritys,field_grant,field_grant.field_authority&filter[field_cis_cluster.title]=${id}&page[offset]=${this.state.offsetproject}&page[limit]=10&sort=-field_project_start_date`)
            .then(data => {
                console.log("clusetr detail projects", data.data)
                this.setState({
                    projects: data.data.data,
                    projectincluded: data.data.included,
                    projectcount: data.data.meta ? data.data.meta.count : null
                })
                if (data.data.links.next)
                    this.setState({
                        projectnext: true
                    })
                else
                    this.setState({
                        projectnext: false
                    })
            })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.tab !== prevState.tab) {
            console.log("else if current tab is", this.state.tab)
        }
        if (prevState.eventcount !== this.state.eventcount || prevState.pubcount !== this.state.pubcount || prevState.projectcount !== this.state.projectcount) {
            if (this.state.events && this.state.pub && this.state.projects) {
                if (this.state.cluster)
                    if (this.state.events.length == 0 && this.state.pub.length !== 0 && this.state.projects.length == 0)
                        this.setState({
                            tab: 1
                        })
                    else if (this.state.events.length == 0 && this.state.pub.length == 0 && this.state.projects.length !== 0)
                        this.setState({
                            tab: 2
                        })
                    else if (this.state.events.length !== 0 && this.state.pub.length == 0 && this.state.projects.length == 0)
                        this.setState({
                            tab: 3
                        })
                    else if (this.state.events.length !== 0 && this.state.pub.length !== 0 && this.state.projects.length == 0)
                        this.setState({
                            tab: 1
                        })
                    else if (this.state.events.length == 0 && this.state.pub.length !== 0 && this.state.projects.length !== 0)
                        this.setState({
                            tab: 1
                        })
                    else if (this.state.events.length !== 0 && this.state.pub.length !== 0 && this.state.projects.length !== 0)
                        this.setState({
                            tab: 1
                        })
                    else if (this.state.events.length !== 0 && this.state.pub.length == 0 && this.state.projects.length !== 0)
                        this.setState({
                            tab: 2
                        })
                    else {
                        console.log("else data is checking")
                        this.setState({
                            tab: this.state.cluster ? this.state.cluster.relationships.field_members_cluster.data.length ? 4 : 1 : 1
                        })
                    }
            }
            else {
                console.log("another else")
                this.setState({
                    tab: 4
                })
            }

        }
        console.log("updating states", prevState, this.state)
        if (prevState.offsetpub !== this.state.offsetpub) {
            this.setState({
                pubnext: false,
                pub: null
            }, () => {
                let link = this.props.match.params.id
                let links = link.replace(/-/g, ' ')
                this.loadDetails(links)
            })
        }
        if (prevState.offsetproject !== this.state.offsetproject) {
            this.setState({
                projectnext: false,
                projects: null
            }, () => {
                let link = this.props.match.params.id
                let links = link.replace(/-/g, ' ')
                this.loadDetails(links)
            })
        }
        if (prevState.offsetevent !== this.state.offsetevent) {
            this.setState({
                eventnext: false,
                events: null
            }, () => {
                let link = this.props.match.params.id
                let links = link.replace(/-/g, ' ')
                this.loadDetails(links)
            })
        }
    }
    render() {
        return (
            <div>
                <Header />
                <div className='title-banner'>
                    <div className='heading-one bold white-text'>
                        Research Clusters
                    </div>
                </div>
                <div className='container research-cluster-page'>
                    <div className='subHeader'>
                        <div className='top-contents'>
                            <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} /> Research  <img className='rightarrow' src={crumbarrow} /> <Link to={'/research/cluster'} className='gray-text'>Research Clusters</Link><img className='rightarrow' src={crumbarrow} />{this.state.cluster ? this.state.cluster.attributes.title ? this.state.cluster.attributes.title : "" : ''}</div>
                            {/* <TopBar data={'data4'} /> */}
                        </div>
                    </div>
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="">
                                <div className="heading-three bold blue-text">{this.state.cluster ? this.state.cluster.attributes.title ? this.state.cluster.attributes.title : "" : ''}</div>
                            </div>
                        </div>
                    </div>
                    {this.state.cluster ? <p className='body-two gray-text text-justify'>
                        {this.state.cluster.attributes.body ? HtmlParser(this.state.cluster.attributes.body.value) : ""}
                    </p> : ""}


                    <div className='projectall_container' style={{ minHeight: "38vh" }}>

                        {
                            <div className='projectsToggle' style={{ marginTop: 0.7 + "rem" }}>
                                <div className="toggle-bar-one">
                                    <button style={{ display: this.state.pub ? this.state.pub.length ? "" : "none" : "none" }} className={this.state.tab === 1 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 1 })}>Publications{this.state.tab === 1 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                    <button style={{ display: this.state.projects ? this.state.projects.length ? "" : "none" : "none" }} className={this.state.tab === 2 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 2 })}>Project Partnerships <br /> & Grants{this.state.tab === 2 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                    <button style={{ display: this.state.events ? this.state.events.length ? "" : "none" : "none" }} className={this.state.tab === 3 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 3 })}>Events{this.state.tab === 3 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                    <button style={{ display: this.state.cluster ? this.state.cluster.relationships.field_members_cluster.data.length ? "" : "none" : "none" }} className={this.state.tab === 4 ? 'blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 4 })}>Members{this.state.tab === 4 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button>
                                </div>
                            </div>
                        }
                        <div style={{ marginTop: 0.7 + "rem", marginLeft: "5%", width: "100%" }}>

                            {this.state.cluster ? <table className='newTable'>
                                {this.state.tab === 1 ?
                                    this.state.pub ? this.state.pub.length ?
                                        <tr className='projectStatus-head'>
                                            <th><p>Title</p></th>
                                            <th className='min-wids'><p>Author (s)</p></th>
                                            <th className='min-wids'><p> Type of Publication</p></th>
                                            <th className='min-wids'><p> Year</p></th>
                                        </tr> : "" : '' : ""}
                                {this.state.tab === 2 ?
                                    this.state.projects ? this.state.projects.length ?
                                        <tr className='projectStatus-head'>
                                            <th><p> Project Name</p></th>
                                            <th style={{ width: 25 + "%" }}><p>Project Lead</p></th>
                                            <th className='min-wids'><p> Granting Institution</p></th>
                                            <th className='min-wids'><p> Year</p></th>
                                        </tr> : "" : '' : ""}
                                {this.state.tab === 3 ?
                                    this.state.events ? this.state.events.length ?
                                        <tr className='projectStatus-head'>
                                            <th style={{ width: 35 + "%" }}><p>Title</p></th>
                                            <th className='min-wids'><p>Type</p></th>
                                            <th className='min-wids'><p> Theme/Speaker</p></th>
                                            <th><p> Year</p></th>
                                        </tr>
                                        :
                                        "" : '' : ""}

                                {
                                    this.state.tab === 1 ?
                                        this.state.pub ? this.state.pub.map((item) => {
                                            return (
                                                <tr className='projectDetails-row'>
                                                    <td className='title'><Link to={`/cis_publication/${item.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${item.attributes.drupal_internal__nid}`}>{item.attributes.title}</Link></td>
                                                    <td className='min-wids' style={{ textAlign: "center" }}>{item.relationships.field_author.data.map(author => {
                                                        let faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                            let id = x.relationships.field_author_faculty.data.filter(y => {
                                                                if (y.id == author.id)
                                                                    return y.id
                                                            })
                                                            if (id.length)
                                                                return id[0].id
                                                        }) : ""
                                                        console.log("faculty in publication", faculty)
                                                        return <p style={{ textAlign: "center" }}>{faculty.length ? <Link to={faculty.length ? `/faculty/${faculty[0].attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}?nid=${faculty[0].attributes.drupal_internal__nid}` : ``}>{this.state.pubincluded.filter(x => x.id == author.id)[0].attributes.title}</Link> : this.state.pubincluded.filter(x => x.id == author.id)[0].attributes.title}</p>
                                                    })}</td>
                                                    <td className='min-wids' style={{ textAlign: "center" }}>{this.state.pubincluded.filter(x => x.id === item.relationships.field_select_work_to_submit.data.id)[0].attributes.name}</td>
                                                    <td className='min-wids' style={{ textAlign: "center" }}>{item.attributes.field_year ? item.attributes.field_year : ""}</td>
                                                </tr>
                                            )
                                        }) : "" :
                                        this.state.tab === 2 ?
                                            this.state.projects ? this.state.projects.map((item) => {
                                                let facultyid
                                                let faculty = []
                                                if (item.relationships.field_lead_project__investigator.data)
                                                    faculty = this.state.faculty ? this.state.faculty.filter(x => {
                                                        let id = x.relationships.field_author_faculty.data.filter(y => {
                                                            if (y.id == item.relationships.field_lead_project__investigator.data.id)
                                                                return y.id
                                                        })
                                                        if (id.length)
                                                            return id[0].id
                                                    }) : ""
                                                if (faculty)
                                                    console.log("faculty in cluster", faculty)
                                                const date = item.attributes.field_project_start_date ? new Date(item.attributes.field_project_start_date) : "";
                                                let grant = item.relationships.field_grant.data.length ? item.relationships.field_grant.data : []
                                                console.log("grant found", item.relationships.field_grant.data)
                                                return (
                                                    <tr className='projectDetails-row'>
                                                        <td className='title'><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                        <td className='min-wids' style={{ textAlign: "center" }}>{item.relationships.field_lead_project__investigator.data ? faculty.length ? <Link to={faculty.length ? `/faculty/${faculty[0].attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}?nid=${faculty[0].attributes.drupal_internal__nid}` : ``}>{this.state.projectincluded.filter(x => x.id == item.relationships.field_lead_project__investigator.data.id)[0].attributes.title}</Link> : this.state.projectincluded.filter(x => x.id == item.relationships.field_lead_project__investigator.data.id)[0].attributes.title : ""}</td>
                                                        <td className='' style={{ textAlign: "center", minWidth: "240px" }}>{grant.length ? grant.map((grants) => {
                                                            let authorityid = this.state.projectincluded.filter(x => x.id === grants.id).length ? this.state.projectincluded.filter(x => x.id === grants.id)[0].relationships.field_authority.data ? this.state.projectincluded.filter(x => x.id === grants.id)[0].relationships.field_authority.data.id : "" : ''

                                                            return (
                                                                <p className="text-center">{authorityid ? this.state.projectincluded.filter(x => x.id == authorityid)[0].attributes.name : ""}</p>
                                                            )
                                                        }) : ""}</td>
                                                        <td className='min-wids' style={{ textAlign: "center" }}>{date ? date.getFullYear() : ""}</td>
                                                    </tr>
                                                )
                                            }) : "" :
                                            this.state.tab === 3 ?
                                                this.state.events ? this.state.events.map((item) => {
                                                    const date = new Date(item.attributes.field_date)
                                                    return (
                                                        <tr className='projectDetails-row'>
                                                            <td className='title'><Link to={`/event_desc/${item.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                            <td className='min-wids' style={{ textAlign: "center" }}>
                                                                {item.relationships.field_event_type.data ? this.state.eventincluded.filter(x => x.id == item.relationships.field_event_type.data.id)[0].attributes.name : ""}
                                                            </td>
                                                            <td className='min-wids' style={{ textAlign: "center" }}>{item.attributes.field_theme_speaker ? item.attributes.field_theme_speaker : ""}</td>
                                                            <td className='min-wids' style={{ textAlign: "center" }}>{date.getFullYear()}</td>
                                                        </tr>
                                                    )
                                                }) : "" :
                                                <div className='cluster_profiles'>
                                                    {this.state.cluster.relationships.field_members_cluster.data ? this.state.cluster.relationships.field_members_cluster.data.length ?
                                                        this.state.cluster.relationships.field_members_cluster.data.map((item, index) => {
                                                            let data = this.state.included.filter(x => x.id === item.id)
                                                            let nameData = this.state.included.filter(x => x.id === item.id)[0].relationships.field_member.data ? this.state.included.filter(x => x.id === item.id)[0].relationships.field_member.data.id : ""
                                                            let names = nameData ? this.state.included.filter(x => x.id == nameData) : null
                                                            let imageid = names ? names[0].relationships.field_image.data ? names[0].relationships.field_image.data.id : "" : ''
                                                            let image = imageid ? this.state.included.filter(x => x.id == imageid) : ""
                                                            if (names)
                                                                return (
                                                                    <div style={{ width: 22.75 + "%", marginRight: (index + 1) % 4 ? "3%" : "0%", marginBottom: 8 + "rem" }}>
                                                                        <div className='image-container'>
                                                                            <img className='clusterMember_pic' src={image ? image[0].attributes.uri ? BASE + image[0].attributes.uri.url : tmp_img : tmp_img} />
                                                                        </div>
                                                                        <Link to={`/faculty/${names[0].attributes.title.replace(/ /g, "-")}?nid=${names[0].attributes.drupal_internal__nid}`} className='body-two bold main-blue-text'>{names ? names[0].attributes.title ? names[0].attributes.title : "" : ''}</Link>
                                                                        <p className='body-two gray-text'>{data ? data[0].attributes.field_designation ? data[0].attributes.field_designation : '' : ""}</p>
                                                                    </div>
                                                                )
                                                        }) : "" : ""}
                                                    {/* {
                                                        members_data.map((item) => {
                                                            return (
                                                                <div style={{ width: 33.3 + "%", marginBottom: 8 + "rem" }}>
                                                                    <img src={item.img} style={{ width: 60 + "%", height: 90 + "%" }} />
                                                                    <p className='clusterName'>{item.name}</p>
                                                                    <p className='cluster_desg'><label>{item.desg}</label></p>
                                                                </div>
                                                            )
                                                        })
                                                    } */}
                                                </div>

                                }
                            </table>
                                : <List />}

                            {this.state.tab === 1 && this.state.pub ? this.state.pub.length ?
                                <div className='new-pagination'>
                                    <button disabled={this.state.offsetpub === 0} onClick={() => this.setState({ offsetpub: this.state.offsetpub - 10 })} className='prev'>{this.state.offsetpub === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetpub ? (this.state.offsetpub / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.pubcount ? Math.ceil(this.state.pubcount / 10) : 1}</div> <button disabled={!this.state.pubnext} onClick={() => this.setState({ offsetpub: this.state.offsetpub + 10 })} className='next'>{this.state.pubnext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                </div>
                                : "" : ''}
                            {this.state.tab === 2 && this.state.projects ? this.state.projects.length ?
                                <div className='new-pagination'>
                                    <button disabled={this.state.offsetproject === 0} onClick={() => this.setState({ offsetproject: this.state.offsetproject - 10 })} className='prev'>{this.state.offsetproject === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetproject ? (this.state.offsetproject / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.projectcount ? Math.ceil(this.state.projectcount / 10) : 1}</div> <button disabled={!this.state.projectnext} onClick={() => this.setState({ offsetproject: this.state.offsetproject + 10 })} className='next'>{this.state.projectnext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                </div>
                                : "" : ''}
                            {this.state.tab === 3 && this.state.events ? this.state.events.length ?
                                <div className='new-pagination'>
                                    <button disabled={this.state.offsetevent === 0} onClick={() => this.setState({ offsetevent: this.state.offsetevent - 10 })} className='prev'>{this.state.offsetevent === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetevent ? (this.state.offsetevent / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.eventcount ? Math.ceil(this.state.eventcount / 10) : 1}</div> <button disabled={!this.state.eventnext} onClick={() => this.setState({ offsetevent: this.state.offsetevent + 10 })} className='next'>{this.state.eventnext ? <img src={pageright} /> : <img src={pagenoright} />}</button>
                                </div>
                                : "" : ''}




                            {/*pagination*/}
                            {/* {
                                this.state.tab === 4 ?
                                    ""
                                    :
                                    <ReactPaginate
                                        nextLabel=">"
                                        // onPageChange={handlePageClick}
                                        // onClick={(e) => setNext(setoffseta(state.offseta + 15))}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={100}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        activeLinkClassName="activePage"
                                        renderOnZeroPageCount={null}
                                    />
                            } */}


                        </div>
                    </div>




                </div>
                <Footer />
            </div>
        )
    }
}
export default Clusters;